import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const FeatureSlideshow = ({ slides }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const prev = () =>
    setCurrent((current - 1 + slides.length) % slides.length);
  const next = () => setCurrent((current + 1) % slides.length);

  return (
    <div
      className="relative w-full max-w-7xl mx-auto
                 h-[420px] md:h-[380px] lg:h-[250px]
                 overflow-hidden rounded-2xl shadow-xl bg-blue-200"
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700
            ${index === current ? "opacity-100 z-10" : "opacity-0 z-0"}`}
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 
  bg-gradient-to-r 
  from-black/30 via-black/10 to-transparent" />

          {/* Content */}
         <div className="relative z-10 h-full flex items-center">
  <div className="px-6 md:px-16 max-w-100xl">
    <div className="bg-white/80 backdrop-blur-md rounded-xl p-6 shadow-lg">
      <h3 className="text-3xl md:text-4xl font-bold text-primary mb-4">
        {slide.title}
      </h3>
      <p className="text-lg text-blue-700">
        {slide.description}
      </p>
    </div>
  </div>
</div>

        </div>
      ))}

      {/* Left Arrow */}
      <Button
        variant="ghost"
        size="icon"
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2
                   bg-black/40 text-white hover:bg-black/60 z-20"
      >
        <ChevronLeft />
      </Button>

      {/* Right Arrow */}
      <Button
        variant="ghost"
        size="icon"
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2
                   bg-black/40 text-white hover:bg-black/60 z-20"
      >
        <ChevronRight />
      </Button>

      {/* Dots */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2
                      flex gap-2 z-20">
        {slides.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full cursor-pointer transition
              ${index === current ? "bg-white" : "bg-white/40"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default FeatureSlideshow;
